<template>
  <div class="dangJianShe">
    <el-form :model="ruleForm" :rules="rules" :disabled="true" ref="ruleForm" label-position="top" class="ruleFormYan">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否开通且正常使用企安安" ref="is_qianan" prop="is_qianan">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_qianan" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否按期自查" ref="is_zicha" prop="is_zicha">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_zicha" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最近一次安全演练时间" ref="last_yan_lian" prop="last_yan_lian">
            <div class="flex justify-start align-center">
              <el-date-picker
                class="inp"
                v-model="ruleForm.last_yan_lian"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最近一次安全演练组织方" ref="zu_zhi" prop="zu_zhi">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.zu_zhi" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="安全演练照片" class="listcontent" ref="an_images" prop="an_images">
            <div class="img-list">
              <div class="img-box" v-for="(item,index) in ruleForm.an_images" :key="index">
                <img :src="item" alt="">
<!--                <i class="iconfont icon-cuo" @click="delImg(index)"></i>-->
              </div>
              <upload-file
                v-if="false"
                name="an_images"
                @uploadFile="uploadFile"
              >
                <div class="img-add" slot="upload">
                  <i class="iconfont icon-a-fenzu1"></i>
                </div>
              </upload-file>

            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
<!--    <div class="btn-box">-->
<!--      <div class="btn pointer" @click="submitForm('ruleForm')">保存</div>-->
<!--    </div>-->
  </div>
</template>
<script>
import {scrollIntoView} from "@/utils/utils";
import {cansaiOptions, isYes} from "@/utils/const";
import UploadFile from "@/components/UploadFile";
import {get_yunying, save_anquan} from "@/api/admin";
export default {
  name: "anquan",
  data() {
    return {
      org_id:'',
      isYes: isYes,
      cansaiOptions: cansaiOptions,
      ruleForm: {
        is_qianan: '', // 是否开通且正常使用企安安
        is_zicha: '', // 是否按期自查
        last_yan_lian: '', // 最近一次安全演练时间
        zu_zhi: '', // 最近一次安全演练组织方
        an_images:[]
      },
      rules: {
        is_qianan: [
          {required: false, message: '请选择', trigger: 'change'}
        ] ,
        is_zicha: [
          {required: false, message: '请选择', trigger: 'change'}
        ] ,
        zu_zhi: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        last_yan_lian: [
          {required: false, message: '请选择', trigger: 'change'}
        ] ,
        an_images: [
          {required: false, message: '请选择', trigger: 'change'}
        ]
      }
    }
  },
  components: {UploadFile},
  created() {
    this.org_id = this.$route.query.org_id
    this.init()
  },
  methods: {
    async init(){
      let _data = await get_yunying(this.org_id,5);
      if(_data.status == 200){
        this.ruleForm = {
          is_qianan: _data.data.is_qianan, // 是否开通且正常使用企安安
          is_zicha: _data.data.is_zicha, // 是否按期自查
          last_yan_lian: _data.data.last_yan_lian, // 最近一次安全演练时间
          zu_zhi: _data.data.zu_zhi, // 最近一次安全演练组织方
          an_images: _data.data.an_images ? _data.data.an_images.split(',') : []
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid, validates) => {
        if (valid) {
          this.submitInfo()
        } else {
          scrollIntoView(this, validates)
        }
      });
    },

    async submitInfo() {
      let _data = await save_anquan(
        this.org_id,
        this.ruleForm.is_qianan,
        this.ruleForm.is_zicha,
        this.ruleForm.last_yan_lian,
        this.ruleForm.zu_zhi,
        this.ruleForm.an_images.join(','),
      );
      if(_data.status == 200){
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },

    uploadFile(data) {
      this.ruleForm[data.name].push(data.file.url);
    },

    delImg(index) {
      this.ruleForm.an_images.splice(index, 1)
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.dangJianShe {

  .img-list {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .img-add {
      width: 160px;
      height: 160px;
      background: #f6f6f6;
      border-radius: 6px;
      text-align: center;
      line-height: 160px;
      margin-bottom: 15px;
      margin-top: 10px;
      cursor: pointer;
      i {
        font-size: 40px;
        color: #999999;
      }
    }
    .img-box {
      width: 160px;
      height: 160px;
      background: #f6f6f6;
      border-radius: 6px;
      position: relative;
      margin-bottom: 15px;
      margin-top: 10px;
      margin-right: 25px;
      img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
      i {
        cursor: pointer;
        font-size: 26px;
        color: #f74945;
        position: absolute;
        right: -13px;
        top: -13px;
      }
    }
  }
  .width {
    width: 400px;
  }

  .title-flex {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 20px;

    b {
      font-size: 18px;
      color: #000000;
      font-weight: bold;
      margin-right: 10px;
    }
  }

  .add {
    width: 24px;
    cursor: pointer;
  }

  .inp {
    flex: 1;
  }

  .tips {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    background-color: #fef0ef;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 14px;
    color: #f34336;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 16px;

    i {
      font-size: 20px;
      color: #f34336;
      margin-right: 4px;
    }

    &.width {
      width: 160px;
    }
  }

  .look {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    border: 1px solid #2791ff;
    color: #2791ff;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    margin-left: 10px;
    border-radius: 4px;
  }

  .btnUp {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    margin-left: 10px;
    background-image: linear-gradient(90deg,
      #2791ff 0%,
      #81b6ff 100%);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ffffff;

    i {
      font-size: 20px;
      color: #ffffff;
      margin-right: 5px;
      font-weight: 100;
    }
  }

  .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 30px 0;

    .btn {
      width: 180px;
      height: 40px;
      background-image: linear-gradient(0deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      letter-spacing: 1px;
      color: #ffffff;
    }
  }
}
</style>


